import { Route } from 'react-router-dom'
import Account from '@/pages/account'
import Orders from '@/pages/orders'
// import Sales from '@/zones/dashboard/sales'
import Statistics from '@/pages/statistics'
import Stock from '@/pages/stock'
import UsersRequest from '@/pages/users-request'
import Users from '@/pages/users'
import ProtectedRoute from './protected-route'
import JwtPayload from '@/entities/api/jwt'
import getPermissionsMap from '@/utils/permissions-convert'
import Categories from '@/pages/categories'
import Coupons from '@/pages/coupons'
import Customers from '@/pages/customers'
import Sales from '@/pages/sales'

const DashboardRoutesModel = ({
	isSession,
	data,
}: {
	isSession: boolean
	data: JwtPayload
}) => {
	const permissions = getPermissionsMap(data?.permissions || [])

	return (
		<>
			<Route
				path='/'
				element={
					<ProtectedRoute isSession={isSession}>
						<Statistics data={data} />
					</ProtectedRoute>
				}
			/>
			<Route
				path='/account'
				element={
					<ProtectedRoute isSession={isSession}>
						<Account data={data} />
					</ProtectedRoute>
				}
			/>
			{permissions.coupons?.view && (
				<Route
					path='/coupons'
					element={
						<ProtectedRoute isSession={isSession}>
							<Coupons data={data} />
						</ProtectedRoute>
					}
				/>
			)}
			{permissions.sales?.view && (
				<Route
					path='/sales'
					element={
						<ProtectedRoute isSession={isSession}>
							<Sales data={data} />
						</ProtectedRoute>
					}
				/>
			)}
			{permissions.orders?.view && (
				<Route
					path='/orders'
					element={
						<ProtectedRoute isSession={isSession}>
							<Orders data={data} />
						</ProtectedRoute>
					}
				/>
			)}
			{permissions.categories?.view && (
				<Route
					path='/categories'
					element={
						<ProtectedRoute isSession={isSession}>
							<Categories data={data} />
						</ProtectedRoute>
					}
				/>
			)}
			{permissions.customers?.view && (
				<Route
					path='/customers'
					element={
						<ProtectedRoute isSession={isSession}>
							<Customers data={data} />
						</ProtectedRoute>
					}
				/>
			)}
			{/* <Route path='/sales' element={<Sales />} /> // no touch */}
			{permissions.inventary?.view && (
				<Route
					path='/stock'
					element={
						<ProtectedRoute isSession={isSession}>
							<Stock data={data} />
						</ProtectedRoute>
					}
				/>
			)}
			{permissions.contact?.view && (
				<Route
					path='/users-request'
					element={
						<ProtectedRoute isSession={isSession}>
							<UsersRequest data={data} />
						</ProtectedRoute>
					}
				/>
			)}
			{permissions.users?.view && (
				<Route
					path='/users'
					element={
						<ProtectedRoute isSession={isSession}>
							<Users data={data} />
						</ProtectedRoute>
					}
				/>
			)}
		</>
	)
}

export default DashboardRoutesModel
